import { PDF } from 'melp-design/icons';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'store/modal';
import { LanguageSelectModal } from 'components/modals';
import { useCompanyLanguages } from 'state/Administrators';
import { useBenefitsPDFDownload } from './hooks/useMultipleBenefitsPDFDownload';

interface Props {
  /**
   * IDs of benefits to generate PDF for.
   */
  benefitIds: string[];
  /**
   * Name of the pdf file
   */
  fileName?: string;
  /**
   * Information for user when there ar no benefit IDs
   */
  noBenefitsHint: string;
  /**
   * Describes the purpose of the button
   */
  hint?: string;
}

const MultipleBenefitsPDFDownloader = (props: Props) => {
  const { t } = useTranslation();
  const { supportedLanguages } = useCompanyLanguages();
  const { openModal } = useModalContext();

  const { downloadPdf, loading: isDownloading } = useBenefitsPDFDownload();

  const noIds = !props.benefitIds.length;
  const tooltipTitle = noIds
    ? props.noBenefitsHint
    : props.hint ?? t('common.downloadPDF');

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          onClick={async () => {
            const response = await openModal({
              component: LanguageSelectModal,
              props: {
                languages: supportedLanguages,
              },
            });

            if (response.action === 'CONFIRM') {
              downloadPdf(props.benefitIds, response.language, props.fileName);
            }
          }}
          disabled={noIds || isDownloading}
          sx={{ margin: '-10px' }}
        >
          <Box
            component="span"
            display="flex"
            alignItems="inherit"
            justifyContent="inherit"
          >
            {isDownloading ? (
              <CircularProgress size={20} style={{ margin: 5 }} />
            ) : (
              // eslint-disable-next-line react/jsx-pascal-case
              <PDF style={{ height: 30, width: 'auto' }} />
            )}
          </Box>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default MultipleBenefitsPDFDownloader;
